import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from "../../config";
import '../../css/uploadResume.css';
import { ToastContainer, toast, Zoom } from "react-toastify";
import { useNavigate } from 'react-router-dom';

if (typeof window !== "undefined") {
     require("react-toastify/dist/ReactToastify.css");
   }

const UploadResume = () => {
  const [resumeFile, setResumeFile] = useState(null);
  const navigate=useNavigate()

  const handleFileChange = (e) => {
    setResumeFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resumeFile) {
      toast.warn("Please select a PDF file", { transition: Zoom });
      return;
    }

    const data = new FormData();
    data.append('resume', resumeFile);

    try {
      await axios.post(`${API_BASE_URL}/api/resumes/upload`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });

      toast.success("Resume uploaded successfully!", { transition: Zoom });
      console.log("Navigating to home page in 1.5 seconds...");

      setTimeout(()=>{
        navigate("/")
      },1300)

setResumeFile(null);
    } catch (err) {
      console.error('Upload error:', err);
      toast.error("Error uploading resume. Please try again.", { transition: Zoom });
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload Resume</h2>
      <form onSubmit={handleSubmit} className="upload-form">
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          required
          className="file-input"
        />
        <button type="submit" className="upload-button">Upload</button>
      </form>

      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
      />
    </div>
  );
};

export default UploadResume;
